import { Form } from '@unform/web';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
  position: relative;
`;

export const WrapperForm = styled(Form)`
  form {
    > div > div {
      margin-bottom: 1rem;
    }
  }
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;

  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(1px);
`;

export const LoadingContent = styled.div`
  position: sticky;
  top: calc(50vh - 120px);

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.75rem;
`;
